interface SummaryModalProps {
  isOpen: boolean
  onClose: () => void
  text?: string
  isLoading: boolean
  error?: string
}

export const SummaryModal = ({ isOpen, onClose, text, isLoading, error }: SummaryModalProps) => {
  if (!isOpen) return null

  return (
    <dialog className="modal modal-open">
      <div className="modal-box max-w-2xl">
        <h3 className="font-bold text-lg mb-4">Суммаризация звонка</h3>
        {isLoading && (
          <div className="flex justify-center items-center py-8">
            <span className="loading loading-spinner loading-lg" />
            <span className="ml-3 text-gray-500">Выполняется анализ...</span>
          </div>
        )}
        {error && !isLoading && (
          <div className="alert alert-error">
            <span>{error}</span>
          </div>
        )}
        {text && !isLoading && <div className="prose max-w-none whitespace-pre-wrap text-sm">{text}</div>}
        <div className="modal-action">
          <button className="btn" onClick={onClose}>
            Закрыть
          </button>
        </div>
      </div>
      <div className="modal-backdrop" onClick={onClose} />
    </dialog>
  )
}
